import * as Yup from "yup";
import { campo_obligatorio } from "../../utils/traductor";

export function initialValues() {
  return {
    codigoactivacion: "",
  };
}

export function validationSchema() {
  return Yup.object({
    codigoactivacion: Yup.string().required(` ${campo_obligatorio} `),
  });
}
